import { render } from "./PengTackReception.vue?vue&type=template&id=8141f9b8&scoped=true"
import script from "./PengTackReception.vue?vue&type=script&lang=js"
export * from "./PengTackReception.vue?vue&type=script&lang=js"

import "./PengTackReception.vue?vue&type=style&index=0&id=8141f9b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8141f9b8"]])

export default __exports__